"use strict";

exports.__esModule = true;
var _CreateAlertWatcherRuleScreen = require("./CreateAlertWatcherRuleScreen");
Object.keys(_CreateAlertWatcherRuleScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateAlertWatcherRuleScreen[key]) return;
  exports[key] = _CreateAlertWatcherRuleScreen[key];
});